import { useContext } from "react";
import { AuthContext } from "../context/authContextValue";
import type { UseAuthResult } from "../types/types";

export function useAuth(): UseAuthResult {
  const contextValue = useContext(AuthContext);
  if (!contextValue) {
    throw new Error("useAuth must be used within AuthProvider.");
  }
  return contextValue;
}
